import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';

import { FACEBOOK_PIXEL_ID } from '@features/Analytics';
import { FACEBOOK_BACKEND_VARIANTS_MAP } from '@features/Analytics/constants';
import type { TpFacebookPostParameters } from '@features/Analytics/types/facebook';
import { axiosMicroservice } from 'src/api/axios';
import { TEST_EVENT_CODE } from 'src/constants/api';
import { getDataFromSessionStorage } from 'src/utils';

export const postFacebookEvent = async ({
  externalId,
  eventId,
  eventName,
  fbp,
  options,
  customData,
}: TpFacebookPostParameters & { fbp: string }) => {
  const fbc = Cookies.get('_fbc');

  const currentPixelId = getDataFromSessionStorage({
    store: 'analyticsStore',
    key: 'fbPixelId',
  });

  try {
    const { data } = await axiosMicroservice.post('fb_event', {
      fbp,
      fbc,
      event_name: eventName,
      event_id: eventId,
      external_id: externalId,
      test_event_code: TEST_EVENT_CODE,
      origin:
        FACEBOOK_BACKEND_VARIANTS_MAP.get(
          currentPixelId || FACEBOOK_PIXEL_ID,
        ) ?? FACEBOOK_BACKEND_VARIANTS_MAP.get(FACEBOOK_PIXEL_ID),
      ...options,
      custom_data: { ...customData },
    });
    return data;
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setExtras({
        event_name: eventName,
        event_id: eventId,
        external_id: externalId,
        fbp,
        fbc,
        pixel_id: currentPixelId || FACEBOOK_PIXEL_ID,
        options,
        custom_data: customData,
      });
      Sentry.captureException(error);
    });
  }
};
